import React from 'react'
import ReactDOM from 'react-dom'
import App from './views/App'

ReactDOM.render(<App />, document.querySelector('#root'))
